import { simpleFetch } from './customFetch';

export const getHeroBanner = () => simpleFetch('/hero-banners/current');

export const getMyBoxDetails = () => simpleFetch('/box-status');

export const getWebCards = () => simpleFetch('/web-cards?limit=18');

export const getSeasonalTimelines = () => simpleFetch('/seasonal-timelines');
